import * as Constants from '../constants';

export function sourceCardOptionClicked(data) {
  return {
    type: Constants.SourceCard.ActionTypes.SOURCE_CARD_OPTION_CLICKED,
    data,
  };
}

export function sourceCardOpened(data) {
  return {
    type: Constants.SourceCard.ActionTypes.SOURCE_CARD_OPENED,
    data,
  };
}
